import { render } from "./stock.vue?vue&type=template&id=3c97de5a&scoped=true"
import script from "./stock.vue?vue&type=script&lang=ts"
export * from "./stock.vue?vue&type=script&lang=ts"

import "./stock.vue?vue&type=style&index=0&id=3c97de5a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c97de5a"

export default script